import { render } from "./BaseTable.vue?vue&type=template&id=3c068857"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=3c068857&lang=css"
script.render = render

export default script